var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 5.20833C3.125 4.0625 4.0625 3.125 5.20833 3.125H13.5417V5.20833H5.20833V19.7917H13.5417V21.875H5.20833C4.0625 21.875 3.125 20.9375 3.125 19.7917V5.20833ZM17.8917 11.4583L15.25 8.81667L16.7229 7.34375L21.8792 12.5L16.7229 17.6562L15.25 16.1833L17.8917 13.5417H11.0312V11.4583H17.8917Z",
    fill: "#D84727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.a396d5fb9250c93be5c2cc7848ec7e8b.svg";
export { ForwardRef as ReactComponent };